<template>
<div>
    <!-- ----------------------------------------------------- -->
    <!-- [API说明] Element-UI：布局组件 ------------------------ -->
    <!-- ----------------------------------------------------- -->
    <!-- · 组件标签：el-row   标签：Element-UI 的 行容器；通过浮动实现；-->
    <!-- · 配套属性：:gutter  属性：指定 24 分栏之间的间隔；-->
    <!-- · 配套属性：type     属性：通过 弹性布局 实现 行容器；-->
    <!-- · 配套属性：justify  属性：设置 弹性布局 的 对齐方式；-->

    <!-- · 组件标签：el-col   标签：Element-UI 的 列容器；-->
    <!-- · 配套属性：:span    属性：指定当前元素在 24 分栏的栅格布局中占据的列数；-->
    <!-- · 配套属性：:offset  属性：通过 左外边距实现列的 占位 与 偏移；-->

    <!-- · 配套属性：:xs      标签：当屏幕 <768px 时，指定当前元素在 24 分栏的栅格布局中占据的列数；-->
    <!-- · 配套属性：:sm      标签：当屏幕 ≥768px 时，指定当前元素在 24 分栏的栅格布局中占据的列数；-->
    <!-- · 配套属性：:md      标签：当屏幕 ≥992px 时，指定当前元素在 24 分栏的栅格布局中占据的列数；-->
    <!-- · 配套属性：:lg      标签：当屏幕 ≥1200px 时，指定当前元素在 24 分栏的栅格布局中占据的列数；-->
    <!-- · 配套属性：:xl      标签：当屏幕 ≥1920px 时，指定当前元素在 24 分栏的栅格布局中占据的列数；-->
    <!--
    <div class="div_000">
        
        <el-row :gutter="0">
            <el-col :span="6"><div class="div_000_001"></div></el-col>
            <el-col :span="6"><div class="div_000_001"></div></el-col>
            <el-col :span="6"><div class="div_000_001"></div></el-col>
            <el-col :span="6"><div class="div_000_001"></div></el-col>
        </el-row>
        
        <el-row :gutter="5">
            <el-col :span="6" :offset="6"><div class="div_000_001"></div></el-col>
            <el-col :span="6"><div class="div_000_001"></div></el-col>
        </el-row>
        
        <el-row type="flex" justify="space-around">
            <el-col :span="6"><div class="div_000_001"></div></el-col>
            <el-col :span="6"><div class="div_000_001"></div></el-col>
            <el-col :span="6"><div class="div_000_001"></div></el-col>
        </el-row>
        
        <el-row :gutter="5">
            <el-col :xs="3" :sm="9" :md="3" :lg="9" :xl="3"><div class="div_000_001"></div></el-col>
            <el-col :xs="9" :sm="3" :md="9" :lg="3" :xl="9"><div class="div_000_001"></div></el-col>
            <el-col :xs="9" :sm="3" :md="9" :lg="3" :xl="9"><div class="div_000_001"></div></el-col>
            <el-col :xs="3" :sm="9" :md="3" :lg="9" :xl="3"><div class="div_000_001"></div></el-col>
        </el-row>
    </div>
    -->
    
    <!-- ----------------- -->
    <!-- ---- 加载动画 ---- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile && (screen_cover_showFlag == 0)" class="div_load_cover" :style="{ 'height' : screenHeight + 'px' }">
        <div>{{randomYear_001}}</div>
    </div>
    
    <div v-if="isMobile && (screen_cover_showFlag == 0)" class="div_mobile_load_cover" :style="{ 'height' : screenHeight + 'px' }">
        <div>{{randomYear_001}}</div>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕一 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_001" :style="{ 'height' : screenHeight + 'px' , 'position' : 'absolute' ,
                                          'top' : scrollTop + 'px'}">
        <div class="div_001_001">
            <div>
                <div>
                    Beyond <span style="font-weight: 600;">NO.</span>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        Thanks to <a style="color: #3C3C3C;" href="https://d4bl.org/" target="_blank">D4BL</a> for making this event possible,
                        giving us a chance to explore social justice in the digital age.
                    </div>
                    <div class="explore_more">
                        <div>Explore more</div><i class="el-icon-right"></i>
                    </div>
                </div>
                <div>
                    Data can paint a picture, but it doesn't always tell the full story.</br>
                    As you move through this experience,
                    you'll see the numbers, reflect on their meaning, and create a memory to carry forward.
                </div>
            </div>
            <div>
                <div><span>Behind&nbsp;data&nbsp;Beyond&nbsp;data</span></div>
            </div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_001">
        <div>
            Beyond <span style="font-weight: 600;">NO.</span>
        </div>
        <div id="Behind_data"> <div>Behind&nbsp;data</div> </div>
        <div id="Beyond_data"> <div>Beyond&nbsp;data</div> </div>
        <div>
            Data can paint a picture, but it doesn't always tell the full story.
            As you move through this experience,
            you'll see the numbers, reflect on their meaning, and create a memory to carry forward.
        </div>
        <div>
            Thanks to <a style="color: #3C3C3C;" href="https://d4bl.org/" target="_blank">D4BL</a> for making this event possible,
            giving us a chance to explore social justice in the digital age.
        </div>
        <div class="explore_more_mobile">
            <div>Explore more</div><i class="el-icon-right"></i>
        </div>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕二 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_002" :style="{ 'height' : screenHeight + 'px' , 'position' : 'absolute' ,
                                          'top' : (screen2_showFlag == 0 ? screenHeight : (screen2_showFlag == 1 ? screenHeight - scrollTop : scrollTop))  + 'px' }">
        <div class="div_002_001">
            <div><div></div>Sample data</div>
            <div>1950&nbsp;-&nbsp;2005</div>
            <div>Social&nbsp;events</div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_002">
        <div><div></div>Sample data</div>
        <div>1950&nbsp;-&nbsp;2005</div>
        <div>Social&nbsp;events</div>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕三 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_003" :style="{ 'height' : screenHeight + 'px', 'position' : 'absolute' ,
                                          'top' : (screen3_showFlag == 0 ? screenHeight*2 : (screen3_showFlag == 1 ? screenHeight*2 - scrollTop : scrollTop))  + 'px' }">
        <img :src="imagePath_001"/>
    </div>
    
    <div v-if="isMobile" class="div_mobile_003">
        <img :src="imagePath_001"/>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕四 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_004" :style="{ 'height' : screenHeight + 'px', 'position' : 'absolute' ,
                                          'top' : (screen4_showFlag == 0 ? screenHeight*3 : (screen4_showFlag == 1 ? screenHeight*3 - scrollTop : scrollTop))  + 'px' }">
        <div class="div_004_001">
            <div><div></div>Social events 1950&nbsp;-&nbsp;2005</div>
            <div></div>
            <div>
                <div>
                    <div><div class="circle_001"></div>Personal Attack</div>
                    <div><div class="circle_002"></div>Riot or Braw</div>
                    <div><div class="circle_003"></div>Verbal or Written Expression</div>
                </div>
                <div>
                    This map shows major social events
                    in the U.S. post-WWII, drawn from the
                    SPEED Project's <a style="color: #3C3C3C;" href="https://uofi.app.box.com/s/96lcwcg4gwqqwm3l9e3eo6wocddt5pqd#Overview" target="_blank">Societal Stability Protocol</a>. 
                    The SSP tracks events that
                    disrupt daily life and raise public
                    anxiety, focusing on four main types:
                    political protests, attacks, state
                    actions, and shifts in political power.
                </div>
            </div>
            <div>
                <!-- <img :src="imagePath_002"/> -->
				<div id="fulltimeline"></div>
            </div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_004">
        <div><div></div>Social events 1950&nbsp;-&nbsp;2005</div>
        <div>
            This map shows major social events
            in the U.S. post-WWII, drawn from the
            SPEED Project's <a style="color: #3C3C3C;" href="https://uofi.app.box.com/s/96lcwcg4gwqqwm3l9e3eo6wocddt5pqd#Overview" target="_blank">Societal Stability Protocol</a>. 
            The SSP tracks events that
            disrupt daily life and raise public
            anxiety, focusing on four main types:
            political protests, attacks, state
            actions, and shifts in political power.
        </div>
        <div>
            <div><div class="circle_mobile_001"></div>Personal Attack</div>
            <div><div class="circle_mobile_002"></div>Riot or Braw</div>
            <div><div class="circle_mobile_003"></div>Verbal or Written Expression</div>
        </div>
        <div>
            <img :src="imagePath_002"/>
        </div>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕五 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_005" :style="{ 'height' : screenHeight + 'px', 'position' : 'absolute' ,
                                          'top' : (screen5_showFlag == 0 ? screenHeight*4 : (screen5_showFlag == 1 ? screenHeight*4 - scrollTop : scrollTop))  + 'px' }">
        <div class="div_005_001">
            <div>Beyond the map,</div>
            <div>what can we</div>
            <div>remember?</div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_005">
        <div><div>Beyond&nbsp;the&nbsp;map,</div></div>
        <div><div>what can we remember?</div></div>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕六 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_006" :style="{ 'height' : screenHeight + 'px', 'position' : 'absolute' ,
                                          'top' : (screen6_showFlag == 0 ? screenHeight*5 : (screen6_showFlag == 1 ? screenHeight*5 - scrollTop : scrollTop))  + 'px' }">
        <div class="div_006_001">
            <div>
                <div class="text_001"><div></div>Behind data</div>
                <div class="text_002">How Data Visualization Helps Us Remember Stories</div>
            </div>
            <div>
                <div class="div_t_001">
                    <div>
                        <span>01</span>
                        
                        <span>Color Legend</span>
                        
                        <span>Each color represents a different
                        type of event—political protests,
                        attacks, state actions, and shifts in
                        power. The legend acts as a key to
                        distinguish each occurrence's
                        nature, making it easier to see the
                        different threads in the story of
                        social change.</span>
                    </div>
                    <div>
                        <span>02</span>
                        
                        <span>Attributes</span>
                        
                        <span>Important details such as event
                        type, location, date, and
                        participants are emphasized to
                        help reveal patterns over time and
                        place. By focusing on these
                        attributes, users can see the
                        bigger picture and remember
                        individual stories within the
                        timeline.</span>
                    </div>
                </div>
                <div class="div_b_001">
                    <div>
                        <span>03</span>
                        
                        <span>Layout</span>
                        
                        <span>Events are organized
                        chronologically across the U.S.,
                        with larger icons for more
                        impactful events. This layout
                        guides users through a timeline of
                        events, helping them understand
                        the sequence and regional effects
                        of each occurrence. Hovering over
                        specific points reveals more
                        details.</span>
                    </div>
                    <div>
                        <span>04</span>
                        
                        <span>Interactive Tooltips</span>
                        
                        <span>Tooltips appear when users hover
                        over each data point, offering
                        additional information (date,
                        description, participants) without
                        cluttering the visual. These tooltips
                        allow for a deeper dive into
                        specific data points, helping users
                        connect emotionally with each
                        story and remember it more
                        vividly.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_006">
        <div><div></div>Behind data</div>
        <div>How Data Visualization Helps Us Remember Stories</div>
        <div>
            <span>01</span>
            
            <span>Color Legend</span>
            
            <span>Each color represents a different
            type of event—political protests,
            attacks, state actions, and shifts in
            power. The legend acts as a key to
            distinguish each occurrence's
            nature, making it easier to see the
            different threads in the story of
            social change.</span>
        </div>
        <div>
            <span>02</span>
            
            <span>Attributes</span>
            
            <span>Important details such as event
            type, location, date, and
            participants are emphasized to
            help reveal patterns over time and
            place. By focusing on these
            attributes, users can see the
            bigger picture and remember
            individual stories within the
            timeline.</span>
        </div>
        <div>
            <span>03</span>
            
            <span>Layout</span>
            
            <span>Events are organized
            chronologically across the U.S.,
            with larger icons for more
            impactful events. This layout
            guides users through a timeline of
            events, helping them understand
            the sequence and regional effects
            of each occurrence. Hovering over
            specific points reveals more
            details.</span>
        </div>
        <div>
            <span>04</span>
            
            <span>Interactive Tooltips</span>
            
            <span>Tooltips appear when users hover
            over each data point, offering
            additional information (date,
            description, participants) without
            cluttering the visual. These tooltips
            allow for a deeper dive into
            specific data points, helping users
            connect emotionally with each
            story and remember it more
            vividly.</span>
        </div>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕七 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_007" :style="{ 'height' : screenHeight + 'px', 'position' : 'absolute' ,
                                          'top' : (screen7_showFlag == 0 ? screenHeight*6 : (screen7_showFlag == 1 ? screenHeight*6 - scrollTop : scrollTop))  + 'px' }">
        <div class="div_007_001">
            <div><div></div>Beyond data</div>
            <div>“Dear data"</div>
            <div>
                <img :src="imagePath_003"/>
            </div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_007">
        <div>
            <div><div></div>Beyond data</div>
            <div>“Dear data"</div>
        </div>
        <div>
            <img :src="imagePath_003"/>
        </div>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕八 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_008" :style="{ 'height' : screenHeight + 'px', 'position' : 'absolute' ,
                                          'top' : (screen8_showFlag == 0 ? screenHeight*7 : (screen8_showFlag == 1 ? screenHeight*7 - scrollTop : scrollTop))  + 'px' }">
        <div class="div_008_001">
            <div>
                Dear Data by </br>
                <span style="font-weight: 600;">Giorgia Lupi & Stefanie Posavec </span>
                A year-long project where two
                designers visualized aspects of
                their daily lives and mailed each
                other the hand-drawn data
                postcards.
            </div>
            <div>
                We prefer to approach data in a
                slower, more analogue way. We've
                always conceived Dear Data as a
                "personal documentary" rather than a
                quantified-self project which is a
                subtle - but important - distinction.
                Instead of using data just to become
                more efficient, we argue we can use
                data to become more humane and to
                connect with ourselves and others at
                a deeper level.
            </div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_008">
        <div>
            Dear Data by </br>
            <span style="font-weight: 600;">Giorgia Lupi & Stefanie Posavec </span></br>
            A year-long project where two
            designers visualized aspects of
            their daily lives and mailed each
            other the hand-drawn data
            postcards.
        </div>
        <div>
            We prefer to approach data in a
            slower, more analogue way. We've
            always conceived Dear Data as a
            "personal documentary" rather than a
            quantified-self project which is a
            subtle - but important - distinction.
            Instead of using data just to become
            more efficient, we argue we can use
            data to become more humane and to
            connect with ourselves and others at
            a deeper level.
        </div>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕九 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_009" :style="{ 'height' : screenHeight + 'px', 'position' : 'absolute' ,
                                          'top' : (screen9_showFlag == 0 ? screenHeight*8 : (screen9_showFlag == 1 ? screenHeight*8 - scrollTop : scrollTop))  + 'px' }">
        <div class="div_009_001">
            <div>Data shows numbers.</div>
		</div>
		<div class="div_009_001">
            <div>Humanity gives them meaning.</div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_009">
        <div><div>Data shows numbers.</div></div>
        <div><div>Humanity gives them meaning.</div></div>
    </div>
    
    <!-- ----------------- -->
    <!-- ----- 屏幕十 ----- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_010" :style="{ 'height' : screenHeight + 'px', 'position' : 'absolute' ,
                                          'top' : (screen10_showFlag == 0 ? screenHeight*9 : (screen10_showFlag == 1 ? screenHeight*9 - scrollTop : scrollTop))  + 'px' }">
        <div class="div_010_001">
            <div>
                <div class="text_003"><div></div>Memorize data</div>
                <div class="text_004">End your journey by creating a personalized postcard to remember these social events.</div>
				<div class="text_005"><input type="text" placeholder="Your first name" v-model="first_name"/></div>
				<div class="text_006"><input type="text" placeholder="Your last name" v-model="last_name"/></div>
				<div class="text_007" @click="create_p5_canvas($event)">{{text_switch}}<i class="el-icon-right"></i></div>
            </div>
            <div>
                <div id="sketch-container"></div>
                <!--
				<div>
                    <div>
                        <span style="font-weight: 600;">{{randomYear_002}}</span>
                        <span>/ unknown month /</span>
                        <span>unknown day</span>
                        <span>Mass Demonstration</span>
                    </div>
                    <div>
                        <span style="font-weight: 600;">{{randomYear_003}}</span>
                        <span>Participants</span>
                        <span>No Weapon Used</span>
                    </div>
                    <div>
                        <span>Nov 18-20th</span>
                        <span>Perez Art Museum Miami</span>
                    </div>
                    <div>
                        <span style="font-weight: 600;">D4BLM</span>
                        <span style="font-weight: 600;">Beyond NO.</span>
                    </div>
                </div>
				-->
            </div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_010">
        <div><div></div>Memorize data</div>
        <div>End your journey by creating a personalized postcard to remember these social events.</div>
		<div><input type="text" placeholder="Your first name" v-model="first_name"/></div>
		<div><input type="text" placeholder="Your last name" v-model="last_name"/></div>
		<div @click="create_p5_canvas($event)">{{text_switch}}<i class="el-icon-right"></i></div>
        <div>
            <div id="sketch-container"></div>
			<!--
			<div>
			    <div>
			        <span style="font-weight: 600;">{{randomYear_002}}</span>
			        <span>/ unknown month /</span>
			        <span>unknown day</span>
			        <span>Mass Demonstration</span>
			    </div>
			    <div>
			        <span style="font-weight: 600;">{{randomYear_003}}</span>
			        <span>Participants</span>
			        <span>No Weapon Used</span>
			    </div>
			    <div>
			        <span>Nov 18-20th</span>
			        <span>Perez Art Museum Miami</span>
			    </div>
			    <div>
			        <span style="font-weight: 600;">D4BLM</span>
			        <span style="font-weight: 600;">Beyond NO.</span>
			    </div>
			</div>
			-->
        </div>
    </div>
    
    <!-- ----------------- -->
    <!-- ---- 屏幕十一 ---- -->
    <!-- ----------------- -->
    
    <div v-if="!isMobile" class="div_011" :style="{ 'height' : screenHeight + 'px', 'position' : 'absolute' ,
                                          'top' : (screen11_showFlag == 0 ? screenHeight*10 : (screen11_showFlag == 1 ? screenHeight*10 - scrollTop : scrollTop))  + 'px' }">
        <div class="div_011_001">
            <div>
                Beyond NO.
            </div>
            <div>
                <div>
                    <div>Design by <span style="border-bottom: 2px solid #E6E2E1;"> Lei Ye</span></div>
                    <div>Develop by <span style="border-bottom: 2px solid #E6E2E1;"> DAO</span></div>
                </div>
                <div>
                    <div>@2024 D4BL</div>
                    <div>Pérez Art Museum Miami</div>
                </div>
            </div>
        </div>
    </div>
    
    <div v-if="isMobile" class="div_mobile_011">
        <div>
            <div>Beyond&nbsp;NO.</div>
        </div>
        <div>Design by &nbsp;<span style="border-bottom: 2px solid #E6E2E1;">Lei Ye</span></div>
        <div>Develop by &nbsp;<span style="border-bottom: 2px solid #E6E2E1;">DAO</span></div>
        <div>@2024 D4BL</div>
        <div>Pérez Art Museum Miami</div>
    </div>
</div>
</template>

<script>

import p5 from 'p5';

import * as d3 from 'd3';

export default {
  data() {
    return {
      isMobile              : false,
      screenHeight          : 0,
      scrollTop             : 0,
      
      screen_cover_showFlag : 0,
      
      screen2_showFlag      : 0,
      screen3_showFlag      : 0,
      screen4_showFlag      : 0,
      screen5_showFlag      : 0,
      screen6_showFlag      : 0,
      screen7_showFlag      : 0,
      screen8_showFlag      : 0,
      screen9_showFlag      : 0,
      screen10_showFlag     : 0,
      screen11_showFlag     : 0,
      screen12_showFlag     : 0,
      screen13_showFlag     : 0,
      
      imagePath_001         : '',
      imagePath_002         : '',
      imagePath_003         : '',

      randomYear_001        : 0,
      randomYear_002        : 0,
      randomYear_003        : 0,
	  
	  randomMonth_001       : 0,
	  randomDate_001        : 0,
	  randomIndex_001       : 0,
	  
	  first_name            : '',
	  last_name             : '',
	  
	  text_switch           : 'Create',
	  text_switch_counter   : 0,
	  
	  text_array            : ['Mass Strike', 'Other Personal Attack', 'Other Property Attack', 'unknown' ],
    };
  },
  created() {
    // 监听；
    window.addEventListener('resize', this.checkIsMobile);
    window.addEventListener('scroll', this.checkScrollTop);
    
    this.imagePath_001 = require('../assets/background.jpg');
    this.imagePath_002 = require('../assets/group_001.svg');
    this.imagePath_003 = require('../assets/group_002.svg');
  },
  mounted() {
    let that = this;
    
	document.title = 'BeyondNO';
	
    // 初始；
    this.checkIsMobile();
    this.checkScreenHeight();
	
    // 遮罩动画 - 随机年份；
    that.randomYear_001 = that.getRandomInt(1954, 2005);
    
    setTimeout( function( ) {
        that.randomYear_001 = that.getRandomInt(1954, 2005);
    }, 2200);
    
    setTimeout( function( ) {
        that.randomYear_001 = that.getRandomInt(1954, 2005);
    }, 3800);
    
    // 遮罩去除；
    setTimeout( function( ) {
        that.screen_cover_showFlag = 1;
    }, 5000);
    
	// 延迟加载 D3;
	setTimeout( function( ) {
	    that.create_d3_canvas();
	}, 6000);
	
	// 延迟加载 P3;
	setTimeout( function( ) {
	    that.create_p5_canvas();
	}, 6000);

  },
  destroyed() {
    window.removeEventListener('resize', this.checkIsMobile);
    window.removeEventListener('scroll', this.checkScrollTop);
  },
  methods: {
    // 检测移动设备；
    checkIsMobile() {
      const width = window.innerWidth || document.documentElement.clientWidth;
      let isMobile_001 = width <= 768;
      
      const userAgent = window.navigator.userAgent;
      let isMobile_002 = /iPhone|iPad|iPod|Android/i.test(userAgent);
       
      this.isMobile = isMobile_001 || isMobile_002;
      
      console.log("移动设备判断方式一：", isMobile_001);
      console.log("移动设备判断方式二：", isMobile_002);
    },
    // 检测屏幕高度；
    checkScreenHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.screenHeight = height;
    },
    // 检测浏览位置；
    checkScrollTop() {
      // console.log('window.pageYOffset                  : ', window.pageYOffset);
      // console.log('document.body.scrollTop             : ', document.body.scrollTop);
      // console.log('document.scrollingElement.scrollTop : ', document.scrollingElement.scrollTop);
      // console.log('document.documentElement.scrollTop  : ', document.documentElement.scrollTop);
      
      const scrollTop = window.pageYOffset || document.scrollingElement.scrollTop || document.documentElement.scrollTop;
      
      this.scrollTop = scrollTop;    // 浏览位置；
      
      console.log(this.scrollTop);
      
      if (this.scrollTop >= 0 && this.scrollTop < (this.screenHeight/2)) {
        console.log("第二块屏幕！");
        
        this.screen2_showFlag = 0,
        this.screen3_showFlag = 0,
        this.screen4_showFlag = 0,
        this.screen5_showFlag = 0,
        this.screen6_showFlag = 0,
        this.screen7_showFlag = 0,
        this.screen8_showFlag = 0,
        this.screen9_showFlag = 0,
        this.screen10_showFlag = 0,
        this.screen11_showFlag = 0,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
        
        this.screen2_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight/2) && this.scrollTop < this.screenHeight) {
        console.log("第三块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 0,
        this.screen4_showFlag = 0,
        this.screen5_showFlag = 0,
        this.screen6_showFlag = 0,
        this.screen7_showFlag = 0,
        this.screen8_showFlag = 0,
        this.screen9_showFlag = 0,
        this.screen10_showFlag = 0,
        this.screen11_showFlag = 0,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
        
        this.screen3_showFlag = 1;
      }
      
      if (this.scrollTop >= this.screenHeight && this.scrollTop < (this.screenHeight + this.screenHeight/2)) {
        console.log("第四块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 0,
        this.screen5_showFlag = 0,
        this.screen6_showFlag = 0,
        this.screen7_showFlag = 0,
        this.screen8_showFlag = 0,
        this.screen9_showFlag = 0,
        this.screen10_showFlag = 0,
        this.screen11_showFlag = 0,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
        
        this.screen4_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight + this.screenHeight/2) && this.scrollTop < (this.screenHeight*2)) {
        console.log("第五块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 2,
        this.screen5_showFlag = 0,
        this.screen6_showFlag = 0,
        this.screen7_showFlag = 0,
        this.screen8_showFlag = 0,
        this.screen9_showFlag = 0,
        this.screen10_showFlag = 0,
        this.screen11_showFlag = 0,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
        
        this.screen5_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight*2) && this.scrollTop < (this.screenHeight*2 + this.screenHeight/2)) {
        console.log("第六块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 2,
        this.screen5_showFlag = 2,
        this.screen6_showFlag = 2,
        this.screen7_showFlag = 0,
        this.screen8_showFlag = 0,
        this.screen9_showFlag = 0,
        this.screen10_showFlag = 0,
        this.screen11_showFlag = 0,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
        
        this.screen6_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight*2 + this.screenHeight/2) && this.scrollTop < (this.screenHeight*3)) {
        console.log("第七块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 2,
        this.screen5_showFlag = 2,
        this.screen6_showFlag = 2,
        this.screen7_showFlag = 2,
        this.screen8_showFlag = 0,
        this.screen9_showFlag = 0,
        this.screen10_showFlag = 0,
        this.screen11_showFlag = 0,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
        
        this.screen7_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight*3) && this.scrollTop < (this.screenHeight*3 + this.screenHeight/2)) {
        console.log("第八块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 2,
        this.screen5_showFlag = 2,
        this.screen6_showFlag = 2,
        this.screen7_showFlag = 2,
        this.screen8_showFlag = 2,
        this.screen9_showFlag = 0,
        this.screen10_showFlag = 0,
        this.screen11_showFlag = 0,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
          
        this.screen8_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight*3 + this.screenHeight/2) && this.scrollTop < (this.screenHeight*4)) {
        console.log("第九块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 2,
        this.screen5_showFlag = 2,
        this.screen6_showFlag = 2,
        this.screen7_showFlag = 2,
        this.screen8_showFlag = 2,
        this.screen9_showFlag = 2,
        this.screen10_showFlag = 0,
        this.screen11_showFlag = 0,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
          
        this.screen9_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight*4) && this.scrollTop < (this.screenHeight*4 + this.screenHeight/2)) {
        console.log("第十块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 2,
        this.screen5_showFlag = 2,
        this.screen6_showFlag = 2,
        this.screen7_showFlag = 2,
        this.screen8_showFlag = 2,
        this.screen9_showFlag = 2,
        this.screen10_showFlag = 2,
        this.screen11_showFlag = 0,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
          
        this.screen10_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight*4 + this.screenHeight/2) && this.scrollTop < (this.screenHeight*5)) {
        console.log("第十一块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 2,
        this.screen5_showFlag = 2,
        this.screen6_showFlag = 2,
        this.screen7_showFlag = 2,
        this.screen8_showFlag = 2,
        this.screen9_showFlag = 2,
        this.screen10_showFlag = 2,
        this.screen11_showFlag = 2,
        this.screen12_showFlag = 0,
        this.screen13_showFlag = 0,
          
        this.screen11_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight*5) && this.scrollTop < (this.screenHeight*5 + this.screenHeight/2)) {
        console.log("第十二块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 2,
        this.screen5_showFlag = 2,
        this.screen6_showFlag = 2,
        this.screen7_showFlag = 2,
        this.screen8_showFlag = 2,
        this.screen9_showFlag = 2,
        this.screen10_showFlag = 2,
        this.screen11_showFlag = 2,
        this.screen12_showFlag = 2,
        this.screen13_showFlag = 0,
          
        this.screen12_showFlag = 1;
      }
      
      if (this.scrollTop >= (this.screenHeight*5 + this.screenHeight/2) && this.scrollTop < (this.screenHeight*6)) {
        console.log("第十三块屏幕！");
        
        this.screen2_showFlag = 2,
        this.screen3_showFlag = 2,
        this.screen4_showFlag = 2,
        this.screen5_showFlag = 2,
        this.screen6_showFlag = 2,
        this.screen7_showFlag = 2,
        this.screen8_showFlag = 2,
        this.screen9_showFlag = 2,
        this.screen10_showFlag = 2,
        this.screen11_showFlag = 2,
        this.screen12_showFlag = 2,
        this.screen13_showFlag = 2,
          
        this.screen13_showFlag = 1;
      }
    },
	// 生成 D3 动态表格；
	create_d3_canvas() {
		
	    var width = 1200, height = 500, margin = 10;
	    
	    d3.selectAll(".fulltimeline").remove();
	    
	    var parseTime = d3.timeParse("%Y%m%d");
	    
	    var tooltip = d3.select("#fulltimeline").append("div").attr("id", "tooltip").style("opacity", 0);
	    
	    var svg = d3.select("#fulltimeline").attr("class", "fulltimeline ft").append("svg").attr("width", width).attr("height", height);
	    
	    svg.style("overflow", "hidden").style("z-index", 0)
	    
	    d3.csv("./d3_data.csv").then(function (data) {
	    
			let actions = [], countries = [];
	
			data.forEach(function (d) {
				if (actions.includes(d.action) == false) {
					actions.push(d.action);
				}
				if (countries.includes(d.country_name) == false) {
					countries.push(d.country_name);
				}
			});

			data = data.filter(function (d) {
				return d.date_text.includes("unknown") == false &&
					d.country_name == "United States" &&
					d.initiator.includes("unknown") == false;
			});
	
			var actionScale = d3.scaleOrdinal().domain(actions).range(["#D03C0E", "#2A357D", "#EAA703"]);
	
			var timeScale = d3.scaleTime()
				.domain(d3.extent(data, function (d) {
					return parseTime(+d.date);
				}))
				.range([margin, width - margin]);
	
			var violenceScale = d3.scaleLinear()
				.domain(d3.extent(data, function (d) {
					return d.violence_policeorstate;
				}))
				.range([3, 10]);
	
			var xaxistext = svg.append("text")
				.attr("class", "tl xaxistext")
				.attr("x", width - margin / 2)
				.attr("y", height - margin / 2)
				/* .text("Timeline") */
				.style("text-anchor", "end")
				.style("fill", "#bcbcbc");
	
			var xaxis = svg.append("g")
				.attr("class", "tl ylxaxis")
				.attr("transform", "translate(0," + height * 0.8 + ")")
				.call(d3.axisBottom(timeScale))
				.style("opacity", 0)
				.transition()
				.delay(3000)
				.style("opacity", 1);
	
			xaxis.transition().selectAll(".ylxaxis line")
				.style("stroke-width", 0.1)
				.style("stroke", "#bcbcbc")
				.style("stroke-dasharray", "1,5")
				.attr("y1", -5)
				.attr("y2", -height * 0.3);
	
			var node = svg.append("g")
				.selectAll("circle")
				.data(data)
				.enter()
				.append("circle")
				.attr("class", function (d) {
					return "tl nodes " + d.eventid;
				})
				.attr("r", function (d) {
					return violenceScale(d.violence_policeorstate)/2;
				})
				.attr("cx", width / 2)
				.attr("cy", height / 2)
				.style("fill", function (d) {
					return actionScale(d.action);
				});
	
			var simulation = d3.forceSimulation()
				.force("x",
					d3.forceX()
					.strength(0.8)
					.x(function (d) {
						return timeScale(parseTime(+d.date));
					}))
				.force("y",
					d3.forceY()
					.strength(0.1)
					.y(height / 2))
				.force("charge", d3.forceManyBody().strength(0.8))
				.force("collide", d3.forceCollide().strength(1)
					.radius(function (d) {
						return violenceScale(d.violence_policeorstate) + 1;
					})
					.iterations(2));
	
			simulation
				.nodes(data)
				.on("tick", function (d) {
					node
						.attr("cx", function (d) {
							return d.x;
						})
						.attr("cy", function (d) {
							return d.y;
						})
				});
	
			// node.on("mouseover", function (event, d) {
			// 
			// 	let tip = "<svg height='10' width='20'><polygon class='tip' points='10,0,20,10,0,10'/></svg>";
			// 
			// 	tooltip.html("<div class='tipp'><div class='tip'>" + tip + "<p class='tooltiptext'>" + d.date_text + " (" + d.day_span + " days) <br><b>" + d.action + "</b> by " + d.initiator + " (" + d.initiator_type + ")<br>" + d.location + "</div></div>");
			// 
			// 	tooltip.style("top", (+this.attributes.cy.value + 30) + "px")
			// 		   .style("left", (+this.attributes.cx.value - 100) + "px")
			// 		   .transition()
			// 		   .style("opacity", 1);
			// 		   
			// }).on("mouseout", function (event, d) {
			// 	tooltip.transition().style("opacity", 0).transition().style("top", 0 + "px")
			// });
	    });
	},
	// 生成 P5 随机图片；
    create_p5_canvas() {
        
        this.$el.querySelector("#sketch-container").innerHTML = "";
		
		this.randomYear_002 = this.getRandomInt(1954, 2005);
		
		this.randomYear_003 = this.getRandomInt(1000, 5000);
		
		this.randomMonth_001 = this.getRandomInt(1, 12);
		
		this.randomDate_001 = this.getRandomInt(1, 30);
		
		this.randomMonth_001 = ('' + this.randomMonth_001).length == 1 ? '0' + this.randomMonth_001 : this.randomMonth_001;
		
		this.randomDate_001 = ('' + this.randomDate_001).length == 1 ? '0' + this.randomDate_001 : this.randomDate_001;
		
		this.randomIndex_001 = this.getRandomInt(0, 3);
		
        // VUE 集成 P5 : npm install p5 --save
		
        const PALETTE1 = [
            ["#F3EFE9"],
        ];
		
		const PALETTE = [
		    ["#000000", "#2A357D", "#EAA703", "#D03C0E"],
		    ["#D03C0E", "#000000", "#2A357D", "#EAA703"],
		    ["#EAA703", "#D03C0E", "#000000", "#2A357D"],
		    ["#2A357D", "#EAA703", "#D03C0E", "#000000"],
		];
        
        const PRESET = {
            WCCCa: [[1,0,1,0,1,0,1,1,1,1,1,1],[1,0,1,0,1,0,1,0,0,0,0,0],[1,0,1,0,1,0,1,0,1,1,1,1],[1,0,1,0,1,0,1,0,1,0,0,0],[1,0,1,0,1,0,1,0,1,0,1,1],[1,0,1,0,1,0,1,0,1,0,1,0],[1,0,1,0,1,0,1,0,1,0,1,1],[1,0,1,0,1,0,1,0,1,0,0,0],[1,0,1,0,1,0,1,0,1,1,1,1],[1,0,1,0,1,0,1,0,0,0,0,0],[1,1,1,1,1,0,1,1,1,1,1,1]],
            WCCCb: [[1,0,1,0,1,0,1,1,1,1,1,1],[1,0,1,0,1,0,1,0,0,0,0,0],[1,0,1,0,1,0,1,1,1,1,1,1],[1,0,1,0,1,0,0,0,0,0,0,0],[1,0,1,0,1,0,1,1,1,1,1,1],[1,0,1,0,1,0,1,0,0,0,0,0],[1,0,1,0,1,0,1,1,1,1,1,1],[1,0,1,0,1,0,0,0,0,0,0,0],[1,0,1,0,1,0,1,1,1,1,1,1],[1,0,1,0,1,0,1,0,0,0,0,0],[1,1,1,1,1,0,1,1,1,1,1,1]],
            BIRB:  [[1,1,1,1,0,1,0,1,1,1,1,1],[1,0,0,1,0,1,0,1,0,0,0,1],[1,0,0,1,0,1,0,1,1,1,1,1],[1,0,0,1,0,1,0,1,0,0,1,0],[1,0,0,1,0,0,0,1,0,0,1,1],[1,1,1,1,1,1,0,0,0,0,0,0],[1,0,0,0,0,1,0,1,1,1,0,0],[1,0,0,0,0,1,0,1,0,1,0,0],[1,0,0,0,0,1,0,1,1,1,1,1],[1,1,1,1,1,1,0,1,0,0,0,1],[0,0,1,0,1,0,0,1,1,1,1,1]],
        };
        
        const SHAPES = {
            W: [{x: -0.5, y: -0.5}, {x: -0.3, y: 0.5}, {x: -0.1, y: 0.5}, {x: 0, y: -0.2}, {x: 0.1, y: 0.5}, {x: 0.3, y: 0.5}, {x: 0.5, y: -0.5}, {x: 0.3, y: -0.5}, {x: 0.2, y: 0.2}, {x: 0.1, y: -0.5}, {x: -0.1, y: -0.5}, {x: -0.2, y: 0.2}, {x: -0.3, y: -0.5}, {x: -0.5, y: -0.5}],
        };
        
        let p5Instance = new p5((p) => {
            const POSTER_WIDTH = 300;
            const POSTER_HEIGHT = 480;
            const CANVAS_SIZE = POSTER_HEIGHT;
        
			const [bgColor] = p.random(PALETTE1);
		
            const [fgColor, colorA, colorB] = p.random(PALETTE);
        
            const PADDING = 100;
            const HALF_PADDING = PADDING / 2;
            let GRID;
        
            const gfx = p.createGraphics(POSTER_WIDTH, POSTER_HEIGHT);
            
            p.setup = () => {
                p.createCanvas(POSTER_WIDTH, POSTER_HEIGHT);
                
                gfx.background(bgColor);
                gfx.noStroke();
                gfx.textFont("Helvetica");
                
                p.random([
                    showWCCCPattern,
                    showBirbPattern,
                    // showWCCCGrid,
                    showSquaresGrid,
                    showCirclesGrid,
                    showDiamondsGrid,
                    showMixGrid,
                ])();
                
                p.background("#ffffff");
				
                showFooterText();
				
                p.imageMode(p.CENTER);
                p.image(gfx, 150, 240, POSTER_WIDTH, POSTER_HEIGHT);
                p.imageMode(p.CORNER);
            }
        
            // CREATE 2D ARRAY 
        
            const array2D = (rows, cols, initValue) =>
                Array.from({ length: rows }, () => Array(cols).fill(initValue))
        
            // SHOW PRESET PATTERN FUNCTION 
        
            const initGridForPreset = (type) => {
                const props = {}
                props.WIDTH = POSTER_WIDTH - PADDING
                props.ROWS = 11
                props.COLS = 12
                props.CELL_SIZE = props.WIDTH / props.COLS
                props.HEIGHT = props.CELL_SIZE * props.ROWS
                props.tx = 50
                props.ty = 50
                props.data = PRESET[type]
                return props
            }
        
            const showPresetPattern = (type) => {
                GRID = initGridForPreset(type)
        
                gfx.push()
                gfx.translate(GRID.tx, GRID.ty)
                GRID.data.forEach((row, y) => {
                    row.forEach((col, x) => {
                        const clr = col === 0 ? colorA : bgColor
                        gfx.stroke(clr)
                        gfx.fill(clr)
                        gfx.square(x * GRID.CELL_SIZE, y * GRID.CELL_SIZE, GRID.CELL_SIZE)
                    })
                })
                gfx.pop()
            }
        
            // SHOW WCCC MOSAIC 
        
            const showWCCCPattern = () => showPresetPattern(p.random(["WCCCa", "WCCCb"]))
         
            // SHOW BIRB MOSAIC 
        
            const showBirbPattern = () => showPresetPattern("BIRB")
        
            // SHOW GRID FUNCTION 
        
            const initGridForGrid = () => {
                const props = {}
                props.WIDTH = POSTER_WIDTH - PADDING
                props.HEIGHT = props.WIDTH
                props.ROWS = gfx.random([3, 4, 5])
                props.COLS = props.ROWS
                props.CELL_SIZE = props.WIDTH / props.COLS
                props.tx = 50
                props.ty = 50
                props.data = array2D(props.ROWS, props.COLS, 0)
                return props
            }
        
            const showGrid = (callback) => {
                GRID = initGridForGrid()
        
                gfx.push()
                gfx.translate(GRID.tx, GRID.ty)
                GRID.data.forEach((row, y) =>
                    row.forEach((_, x) => {
                        const posX = x * GRID.CELL_SIZE + GRID.CELL_SIZE / 2
                        const posY = y * GRID.CELL_SIZE + GRID.CELL_SIZE / 2
                        callback(posX, posY)
                    })
                )
                gfx.pop()
            }
        
            // CIRCLES GRID 
        
            const circle = (posX, posY, color, size) => {
                gfx.push()
                gfx.fill(color)
                gfx.circle(posX, posY, size)
                gfx.pop()
            }
        
            const showCirclesGrid = () =>
                showGrid((posX, posY) =>
                    circle(posX, posY, gfx.random([colorA, colorB]), GRID.CELL_SIZE)
                )
        
            // SQUARES GRID 
        
            const square = (posX, posY, color, size) => {
                gfx.push()
                gfx.fill(color)
                gfx.rectMode(gfx.CENTER)
                gfx.translate(posX, posY)
                gfx.angleMode(gfx.DEGREES)
                gfx.rotate(0)
                gfx.square(0, 0, size)
                gfx.pop()
            }
        
            const showSquaresGrid = () =>
                showGrid((posX, posY) =>
                    square(posX, posY, gfx.random([colorA, colorB]), GRID.CELL_SIZE * 0.85)
                )
        
            // DIAMONDS GRID 
        
            const diamond = (posX, posY, color, size) => {
                const SQRT_2 = 1.41421356237
                gfx.push()
                gfx.fill(color)
                gfx.rectMode(gfx.CENTER)
                gfx.translate(posX, posY)
                gfx.angleMode(gfx.DEGREES)
                gfx.rotate(45)
                gfx.square(0, 0, size * SQRT_2 * 0.5)
                gfx.pop()
            }
        
            const showDiamondsGrid = () =>
                showGrid((posX, posY) =>
                    diamond(posX, posY, gfx.random([colorA, colorB]), GRID.CELL_SIZE, 45)
                )
        
            // CIRCLES + SQUARES + DIAMONDS GRID 
        
            const showMixGrid = () =>
                showGrid((posX, posY) => {
                    const SCALE = 0.85
                    const SIZE = GRID.CELL_SIZE * SCALE
                    const props = [posX, posY, gfx.random([colorA, colorB]), SIZE]
                    gfx.random([circle, square, diamond])(...props)
                })
        
            // WCCC GRID 
        
            const W = (posX, posY, color, size) => {
                gfx.push()
                gfx.translate(posX, posY)
                gfx.scale(size)
                gfx.noStroke()
                gfx.fill(color)
                gfx.beginShape()
                SHAPES.W.forEach(({ x, y }) => gfx.vertex(x, y))
                gfx.endShape()
                gfx.pop()
            }
        
            const C = (posX, posY, color, size) => {
                gfx.push()
                gfx.angleMode(gfx.DEGREES)
                gfx.translate(posX, posY)
                gfx.fill(color)
                gfx.arc(0, 0, 1 * size, 1 * size, 30, 330)
                gfx.fill(bgColor)
                gfx.circle(0, 0, 0.5 * size)
                gfx.pop()
            }
        
            const showWCCCGrid = () =>
                showGrid((posX, posY) =>
                    gfx.random() < 0.5
                        ? W(posX, posY, colorA, GRID.CELL_SIZE)
                        : C(posX, posY, colorB, GRID.CELL_SIZE)
                )
        
			// SHOW FOOTER TEXT FUNCTION 
			
			const showFooterText = () => {
				const TEXT_SIZE = 13;
				
				showText({
					text: this.randomYear_002 + "\n/" + this.randomMonth_001 + "/" + this.randomDate_001 + "\n" + this.text_array[this.randomIndex_001],
					posX: 30,
					posY: 350,
					color: "#3C3C3C",
					size: TEXT_SIZE,
					align: [gfx.LEFT, gfx.CENTER],
				});
				
				if ( this.first_name == '' && this.last_name == '' ) {
					showText({
						text: "First name\nLast name",
						posX: 200,
						posY: 350,
						color: "#3C3C3C",
						size: TEXT_SIZE,
						align: [gfx.LEFT, gfx.CENTER],
					});
				}
				
				if ( this.first_name != '' || this.last_name != '' ) {
					showText({
						text: this.first_name + "\n" + this.last_name,
						posX: 200,
						posY: 350,
						color: "#3C3C3C",
						size: TEXT_SIZE,
						align: [gfx.LEFT, gfx.CENTER],
					});
				}
				
				showText({
					text: "Nov 18-20th\nPérez Art Museum\nMiami",
					posX: 30,
					posY: 420,
					color: "#3C3C3C",
					size: TEXT_SIZE,
					align: [gfx.LEFT, gfx.CENTER],
				});
				
				showText({
					text: "D4BL\nBeyond NO.",
					posX: 200,
					posY: 420,
					color: "#3C3C3C",
					size: TEXT_SIZE,
					align: [gfx.LEFT, gfx.CENTER],
				});
			}
			
            // SHOW TEXT FUNCTION 
        
            const showText = ({ text, posX, posY, color, size, align } = {}) => {
                gfx.push()
                gfx.fill(color)
                gfx.textSize(size)
                gfx.textAlign(...align)
                gfx.text(text, posX, posY)
                gfx.pop()
            }
            
        // this.$el 可以理解为 this.document；  
        }, this.$el.querySelector("#sketch-container") );
		
		this.text_switch_counter = this.text_switch_counter + 1;
		
		if ( this.text_switch_counter >= 2 ) {
			p5Instance.save("D4BL_" + this.first_name + "_" + this.last_name + ".png");
		}
	},
	// 随机生成 min ~ max 之间的数字；
    getRandomInt(min, max) {
      var min = Math.ceil(min);
      var max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  }
};
</script>

<style scoped>
/* ********************************************* */
/* ***************** 加载动画 ******************* */
/* ********************************************* */

@keyframes change {
    0%    { transform : scale(1); opacity : 1 ; font-size: 50px; }
    
    10%   { transform : scale(1); opacity : 1 ; font-size: 50px; }
    15%   { transform : scale(0.9); opacity : 0 ; font-size: 0px;  }
    20%   { transform : scale(1); opacity : 1 ; font-size: 50px; }
    
    /* 30% 保持 */
    
    50%   { transform : scale(1); opacity : 1 ; font-size: 50px; }
    55%   { transform : scale(0.9); opacity : 0 ; font-size: 0px;  }
    60%   { transform : scale(1); opacity : 1 ; font-size: 50px; }
    
    /* 30% 保持 */
    
    90%   { transform : scale(1); opacity : 1 ; font-size: 50px; }
    95%   { transform : scale(0.9); opacity : 0 ; font-size: 0px;  }
    100%  { transform : scale(1); opacity : 1 ; font-size: 50px; }
}

@keyframes out {
    0%    { opacity : 1 ; }
    100%  { opacity : 0 ; }
}

@keyframes scroll_001 {
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
}

.div_load_cover {
    position: fixed;
    top: 0px;
    left: 0px;
    
    width: 100%;
    
    background-color: #E6E2E1;
    
    z-index: 999999;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    animation-name : out;
    animation-duration : 1s;
    animation-delay : 4s;
}

.div_load_cover div {
    width: 200px;
    height: 200px;
    
    border-radius: 200px;
    
    font-size: 50px;
    font-weight: 600;
    
    color: #E6E2E1;
    background-color: #3C3C3C;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    animation-name : change;
    animation-duration : 4s;
}

.div_mobile_load_cover {
    position: fixed;
    top: 0px;
    left: 0px;
    
    width: 100%;
    
    background-color: #E6E2E1;
    
    z-index: 999999;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    animation-name : out;
    animation-duration : 1s;
    animation-delay : 4s;
}

.div_mobile_load_cover div {
    width: 200px;
    height: 200px;
    
    margin-top: 220px;
    
    border-radius: 200px;
    
    font-size: 50px;
    font-weight: 600;
    
    color: #E6E2E1;
    background-color: #3C3C3C;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    animation-name : change;
    animation-duration : 4s;
}

/* ********************************************* */
/* ***************** PC 端样式 ****************** */
/* ********************************************* */

/*
.div_000 {
    width: 100%;
    height: 500px;
}

.div_000_001 {
    width: 100%;
    height: 50px;
    background-color: #ccc;
}
*/

.div_001 {
    width: 100%;
    margin: 0 auto;
    background-color: #E6E2E1;
    
    z-index: 0;
}

.div_001_001 {
    /* width: 1340px; */ width: 100%;
    height: 100%;
    margin: 0 auto;
    background-color: #E6E2E1;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

/* 顶部 */
.div_001_001 > div:first-child {
    flex-basis: 15%;
    /* width: 1340px; */ width: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_001_001 > div:first-child div {
    margin-left: 32px;
	font-size: 24px;
}

/* 中部 */
.div_001_001 > div:nth-child(2) {
    flex-basis: 30%;
    /* width: 1340px; */ width: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_001_001 > div:nth-child(2) > div:first-child {
    flex-basis: 380px;
    height: 70%;
    margin-left: 32px;
    text-align: left;
    
    font-size: 16px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : flex-start;
	
	align-self: flex-start;
}

.explore_more {
    width: 180px;
    flex-basis: 50px;
    line-height: 50px;
    text-align: left;
    
    position: relative;
}

.explore_more > div {
    width: 100%;
    
    border-bottom: 2px solid #3C3C3C;
    
    transition-property : all;
    transition-duration : 0.5s;
    transition-timing-function : linear;
}

.explore_more > div:hover {
    width: 85%;
}

.explore_more > i {
    position: absolute;
    top: 13px;
    right: 0px;
}

.div_001_001 > div:nth-child(2) > div:last-child {
    flex-basis: 480px;
    height: 100%;
    margin-right: 32px;
    text-align: left;
    
    font-size: 20px;
    font-weight: 600;
}

/* 底部 */
.div_001_001 > div:last-child {
    flex-basis: 55%;
    /* width: 1340px; */ width: 100%;

	overflow-x: scroll;
}

.div_001_001 > div:last-child::-webkit-scrollbar {
    display: none;
}

.div_001_001 > div:last-child div {
    width: 2000px;
	height: 100%;
	
	position: relative;
	
	font-size: 160px;
	font-weight: 600;
	color: #3C3C3C;
	
	animation: scroll_001 30s linear infinite;
}

.div_001_001 > div:last-child div span {
	font-size: 160px;
	font-weight: 600;
	color: #3C3C3C;
	
	position: absolute;
	left: 200px;
	bottom: 0px;
}

.div_002 {
    width: 100%;
    margin: 0 auto;
    background-color: #3C3C3C;
    color: #ffffff;
    
    z-index: 100;
}

.div_002_001 {
    /* width: 1340px; */ width: 100%;
    height: 100%;
    margin: 0 auto;
    
    font-size: 160px;
    font-weight: 600;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_002_001 > div:first-child {
    width: 100%;
    font-size: 24px;
    font-weight: 600;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_002_001 > div:first-child > div {
    width: 10px;
    height: 10px;
    margin-left: 32px;
    margin-right: 20px;
    border-radius: 10px;
    background-color: #ffffff;
}

.div_003 {
    width: 100%;
    margin: 0 auto;
    
    z-index: 200;
}

.div_003 > img {
    width: 100%;
}

.div_004 {
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;
    color: #3C3C3C;
    
    z-index: 300;
}

.div_004_001 {
    /* width: 1340px; */ width: 100%;
    height: 100%;
    margin: 0 auto;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_004_001 > div:first-child {
    width: 100%;
    flex-basis: 15%;
    font-size: 24px;
    font-weight: 600;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_004_001 > div:first-child > div {
    width: 10px;
    height: 10px;
    margin-left: 32px;
    margin-right: 20px;
    border-radius: 10px;
    background-color: #3C3C3C;
}

.div_004_001 > div:nth-child(2) {
}

.div_004_001 > div:nth-child(2) > div {
    width: 135px;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    margin-left: 90px;
    border-bottom: 2px solid #3C3C3C;
}

.div_004_001 > div:nth-child(3) {
    width: 100%;
    flex-basis: 20%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_004_001 > div:nth-child(3) > div:first-child {
    flex-basis: 30%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-end;
    align-items : center;
}

.div_004_001 > div:nth-child(3) > div:first-child > div {
    width: 100%;
    margin: 5px 0px;
    
    font-size: 14px;
    font-weight: 600;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.circle_001,
.circle_002,
.circle_003 {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    margin: 0px 10px 0px 55px;
}

.circle_001 {
    background-color: #D03C0E;
}

.circle_002 {
    background-color: #2A357D;
}

.circle_003 {
    background-color: #EAA703;
}

.div_004_001 > div:nth-child(3) > div:last-child {
    flex-basis: 30%;
    height: 100%;
    
    margin-right: 32px;
    
    font-size: 20px;
    font-weight: 600;
    text-align: left;
}

.div_004_001 > div:nth-child(4) {
    width: 100%;
    flex-basis: 60%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-end;
    align-items : center;
}

.div_004_001 > div:nth-child(4) > img {
    width: 60%;
}

.div_005 {
    width: 100%;
    margin: 0 auto;
    background-color: #E6E2E1;

    z-index: 400;
}

.div_005_001 {
    /* width: 1340px; */ width: 100%;
    height: 100%;
    margin: 0 auto;
    color: #3C3C3C;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_005_001 > div {
    flex-basis: 33%;
    font-size: 160px;
    font-weight: 600;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

.div_006 {
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;
    
    z-index: 500;
}

.div_006_001 {
    /* width: 1340px; */ width: 100%;
    height: 100%;
    margin: 0 auto;
    color: #3C3C3C;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_006_001 > div:first-child {
    flex-basis: 40%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.text_001 {
    flex-basis: 20%;
    font-size: 24px;
    font-weight: 600;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.text_001 > div {
    width: 10px;
    height: 10px;
    background-color: #E6E2E1;
    margin: 20px;
	margin-left: 32px;
    border-radius: 10px;
}

.text_002 {
    width: 50%;
    flex-basis: 30%;
    
    margin-left: 32px;
    
    text-align: left;
    font-size: 24px;
    font-weight: 600;
}

.div_006_001 > div:last-child {
    flex-basis: 60%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : center;
}

.div_t_001 {
    flex-basis: 50%;
    width: 100%;
    
	font-size: 20px;
	
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_t_001 > div:first-child {
    flex-basis: 50%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_t_001 > div:last-child {
    flex-basis: 50%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_b_001 {
    flex-basis: 50%;
    width: 100%;
	
    font-size: 20px;
	
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_b_001 > div:first-child {
    flex-basis: 50%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_b_001 > div:last-child {
    flex-basis: 50%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_t_001 div span:first-child,
.div_b_001 div span:first-child {
    width: 80%;
    flex-basis: 30px;
    margin-top: 50px;
    text-align: left;
    font-weight: 600;
    color: #3C3C3C;
}

.div_t_001 div span:nth-child(2),
.div_b_001 div span:nth-child(2) {
    width: 80%;
    flex-basis: 30px;
    text-align: left;
    font-weight: 600;
    color: #3C3C3C;
    border-bottom: 2px solid #3C3C3C;
}

.div_t_001 div span:last-child,
.div_b_001 div span:last-child {
    width: 80%;
    flex-basis: 100px;
    text-align: left;
    margin-top: 15px;
    color: #8A8A8A;
    line-height: 24px;
}

.div_007 {
    width: 100%;
    margin: 0 auto;
    background-color: #3C3C3C;

    z-index: 600;
}

.div_007_001 {
    /* width: 1340px; */ width: 100%;
    height: 100%;
    margin: 0 auto;
    color: #ffffff;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_007_001 > div:first-child {
    width: 100%;
    flex-basis: 10%;
    font-size: 24px;
    font-weight: 600;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_007_001 > div:first-child > div {
    width: 10px;
    height: 10px;
    margin-left: 32px;
    margin-right: 20px;
    border-radius: 10px;
    background-color: #ffffff;
}

.div_007_001 > div:nth-child(2) {
    width: 100%;
    flex-basis: 30%;
    font-size: 160px;
    font-weight: 600;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

.div_007_001 > div:last-child {
    width: 100%;
    flex-basis: 60%;
    font-size: 25px;
    background-color: #ffffff;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_007_001 > div:last-child > img {
    width: 549px;
}

.div_008 {
    width: 100%;
    margin: 0 auto;
    background-color: #3C3C3C;

    z-index: 700;
}

.div_008_001 {
    /* width: 1340px; */ width: 100%;
    height: 100%;
    margin: 0 auto;
    color: #ffffff;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : flex-start;
}

.div_008_001 > div:first-child {
    flex-basis: 35%;
    font-size: 24px;
    text-align: left;
    margin: 60px 20px 0px;
}

.div_008_001 > div:last-child {
    flex-basis: 35%;
    font-size: 24px;
    text-align: left;
    margin: 60px 20px 0px;
}

.div_009 {
    width: 100%;
    margin: 0 auto;
    background-color: #E6E2E1;

    z-index: 800;
	
	display : flex;
	flex-direction : column;
	justify-content : flex-start;
	align-items : center;
	
	overflow: hidden;
}

.div_009_001 {
	width: 100%;
	
	flex-basis: 50%;
	
	position: relative;
	
	overflow-x: scroll;
}

.div_009_001::-webkit-scrollbar {
    display: none;
}

.div_009_001 div:first-child {
	
	width: 2000px;
	
    font-size: 160px;
    font-weight: 600;
    color: #3C3C3C;
	
	position: absolute;
	bottom: 10px;
	left: 100px;
	
	text-align: left;
	
	animation: scroll_001 25s linear infinite;
}

.div_009_001 div:last-child {
	
	width: 2500px;
	
    font-size: 160px;
    font-weight: 600;
    color: #3C3C3C;
	
	position: absolute;
	bottom: 10px;
	left: 100px;
	
	text-align: left;
	
	animation: scroll_001 30s linear infinite;
}

.div_010 {
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;

    z-index: 900;
}

.div_010_001 {
    /* width: 1340px; */ width: 100%;
    height: 100%;
    margin: 0 auto;
    color: #3C3C3C;
    font-size: 24px;
	
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_010_001 > div:first-child {
    flex-basis: 30%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.text_003 {
    flex-basis: 20%;
    font-size: 24px;
    font-weight: 600;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.text_003 > div {
    width: 10px;
    height: 10px;
    background-color: #3C3C3C;
    margin: 20px;
	margin-left: 32px;
    border-radius: 10px;
}

.text_004 {
    width: 80%;
    flex-basis: 15%;
    
    margin-left: 32px;
    
    text-align: left;
    font-size: 24px;
    font-weight: 600;
}

.text_005 {
    width: 45%;
    flex-basis: 10%;
    
	margin-top: 20px;
    margin-left: 32px;
    
    text-align: left;
    font-size: 16px;
    font-weight: 600;
}

.text_006 {
    width: 45%;
    flex-basis: 10%;
    
    margin-left: 32px;
    
    text-align: left;
    font-size: 16px;
    font-weight: 600;
}

.text_005 > input,
.text_006 > input {
    width: 100%;
	font-size: 16px;
	border: none;
    border-bottom: 2px solid #3C3C3C;
}

.text_005 > input:focus, 
.text_005 > input:focus-visible, 
.text_005 > input:-webkit-autofill, 
.text_005 > input:-webkit-autofill:hover, 
.text_005 > input:-webkit-autofill:focus {
    outline: none;
    -webkit-text-fill-color: #333;
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    border: none;
    background-color: white;
	border-bottom: 2px solid #3C3C3C;
}

.text_006 > input:focus, 
.text_006 > input:focus-visible, 
.text_006 > input:-webkit-autofill, 
.text_006 > input:-webkit-autofill:hover, 
.text_006 > input:-webkit-autofill:focus {
    outline: none;
    -webkit-text-fill-color: #333;
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    border: none;
    background-color: white;
	border-bottom: 2px solid #3C3C3C;
}

.text_007 {
    width: 45%;
    flex-basis: 5%;
    
    margin-left: 32px;
    
    text-align: left;
    font-size: 16px;
    
    border-bottom: 2px solid #3C3C3C;
    cursor: pointer;
    
    position: relative;
}

.text_007 > i {
    position: absolute;
    top: 0px;
    right: 0px;
}

.div_010_001 > div:last-child {
    flex-basis: 70%;
    height: 80%;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    position: relative;
}
/* 
.div_010_001 > div:last-child > div:last-child {
    position: absolute;
    bottom: 0px;
    z-index: 9999;
    
    width: 360px;
    height: 170px;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    flex-wrap: wrap;
}

.div_010_001 > div:last-child > div:last-child > div {
    flex-basis: 50%;
    height: 40%;
    margin-top: 10px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_010_001 > div:last-child > div:last-child > div > span {
    width: 80%;
    margin-left: 20px;
    text-align: left;
    font-size: 15px;
} */

.div_011 {
    width: 100%;
    margin: 0 auto;
    background-color: #3C3C3C;

    z-index: 1000;
}

.div_011_001 {
    /* width: 1340px; */ width: 100%;
    height: 100%;
    margin: 0 auto;
    color: #ffffff;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_011_001 > div:first-child {
    flex-basis: 60%;
    font-size: 160px;
    font-weight: 600;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

.div_011_001 > div:last-child {
    flex-basis: 30%;
    width: 100%;
    font-size: 20px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_011_001 > div:last-child > div:first-child {
    flex-basis: 30%;
    margin-left: 32px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-end;
    align-items : center;
}

.div_011_001 > div:last-child > div:last-child {
    flex-basis: 30%;
    margin-right: 50px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-end;
    align-items : center;
}

.div_011_001 > div:last-child > div:first-child div,
.div_011_001 > div:last-child > div:last-child div {
    width: 70%;
    color: #E6E2E1;
    margin-top: 10px;
    text-align: left;
}

/* ********************************************* */
/* *************** Mobile 端样式 **************** */
/* ********************************************* */

.div_mobile_001 {
    width: 100%;
    height: 1000px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
    flex-wrap: nowrap;
    
    background-color: #E6E2E1;
}

.div_mobile_001 > div:first-child {
/*    width: 90%;
    margin: 0 auto; */
	
	padding: 0px 20px;
    flex-basis: 50px;
    line-height: 50px;
    text-align: left;
	
	font-size: 24px;
}

.div_mobile_001 > div:nth-child(2) {
    width: 100%;
	
    flex-basis: 200px;
    
    overflow-x: scroll;
}

.div_mobile_001 > div:nth-child(2)::-webkit-scrollbar {
    display: none;
}

.div_mobile_001 > div:nth-child(2) > div {
    width: 1000px;
	
    line-height: 180px;
    font-size: 128px;
    font-weight: 600;
    color: #3C3C3C;
	text-align: left;
    
	margin-left: 150px;
	
    animation: scroll_001 30s linear infinite;
}

.div_mobile_001 > div:nth-child(3) {
    width: 100%;
	
    flex-basis: 200px;
    
    overflow-x: scroll;
}

.div_mobile_001 > div:nth-child(3)::-webkit-scrollbar {
    display: none;
}

.div_mobile_001 > div:nth-child(3) > div {
    width: 1000px;
	
    line-height: 180px;
    font-size: 128px;
    font-weight: 600;
    color: #3C3C3C;
	text-align: left;
	
	margin-left: 150px;
    
    animation: scroll_001 30s linear infinite;
}

.div_mobile_001 > div:nth-child(4) {
/*    width: 90%;
    margin: 0 auto; */
	
	padding: 0px 20px;
    
    flex-basis: 300px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    font-size: 24px;
    font-weight: 600;
    
    text-align: left;
}

.div_mobile_001 > div:nth-child(5) {
/*    width: 90%;
    margin: 0 auto; */
	
	padding: 0px 20px;
	
    flex-basis: 150px;
    
    font-size: 20px;
    
    text-align: left;
}

.explore_more_mobile {
    flex-basis: 50px;
    line-height: 50px;
    text-align: left;
    
    position: relative;
	
	width: 50%;
	
	margin: 20px 20px 0px 20px;
	
	font-size: 20px;
}

.explore_more_mobile > div {
    width: 100%;
    font-weight: 600;
    
    border-bottom: 2px solid #3C3C3C;
    
    transition-property : all;
    transition-duration : 0.5s;
    transition-timing-function : linear;
}

.explore_more_mobile > i {
    position: absolute;
    top: 13px;
    right: 0px;
}

.div_mobile_002 {
    width: 100%;
    height: 250px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
    flex-wrap: nowrap;
    
    color: #ffffff;
    
    background-color: #3C3C3C;
}

.div_mobile_002 > div:first-child {
    /* width: 60%; */
    
    flex-basis: 20%;
    
	margin-left: 10px;
	
	font-size: 24px;
	font-weight: 600;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_002 > div:first-child > div {
    width: 10px;
    height: 10px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 10px;
    background-color: #ffffff;
}

.div_mobile_002 > div:nth-child(2) {
    width: 100%;
    flex-basis: 128px;
    font-size: 60px;
    font-weight: 600;
    color: #ffffff;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_002 > div:last-child {
    width: 100%;
    flex-basis: 125px;
    font-size: 60px;
    font-weight: 600;
    color: #ffffff;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_003 {
    width: 100%;
    height: 220px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    overflow-x: scroll;
}

.div_mobile_003::-webkit-scrollbar {
    display: none;
}

.div_mobile_003 > img {
    width: 100%;
}

.div_mobile_004 {
    width: 100%;
    height: 930px;
    
    color: #3C3C3C;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
    
    overflow-x: scroll;
}

.div_mobile_004::-webkit-scrollbar {
    display: none;
}

.div_mobile_004 > div:first-child {
    width: 100%;
    
    flex-basis: 20px;
    
    margin-top: 10px;
    margin-left: 10px;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
	
	font-size: 24px;
	font-weight: 600;
}

.div_mobile_004 > div:first-child > div {
    width: 10px;
    height: 10px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 10px;
    background-color: #3C3C3C;
}

.div_mobile_004 > div:nth-child(2) {
    /* width: 95%; */
    
    flex-basis: 350px;
    
    margin-top: 10px;
	margin-left: 20px;
	margin-right: 20px;
	
    font-size: 24px;
    font-weight: 600;
    text-align: left;
}

.div_mobile_004 > div:nth-child(3) {
    /* width: 100%; */
    
    flex-basis: 100px;
    
	margin-top: 25px;
	margin-bottom: 25px;
	margin-left: 8px;
	
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_004 > div:nth-child(3) > div {
    width: 100%;
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
	
	font-size: 20px;
}

.circle_mobile_001,
.circle_mobile_002,
.circle_mobile_003 {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    margin: 0px 10px 0px 15px;
}

.circle_mobile_001 {
    background-color: #D03C0E;
}

.circle_mobile_002 {
    background-color: #2A357D;
}

.circle_mobile_003 {
    background-color: #EAA703;
}

.div_mobile_004 > div:last-child {
    width: 100%;
    
    flex-basis: 500px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : flex-start;
    
    overflow-x: scroll;
}

.div_mobile_004 > div:last-child::-webkit-scrollbar {
    display: none;
}

.div_mobile_004 > div:last-child > img {
    width: 1000px;
}

.div_mobile_005 {
    width: 100%;
    height: 320px;
    overflow-x: scroll;
    
    background-color: #E6E2E1;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : flex-start;
}

.div_mobile_005::-webkit-scrollbar {
    display: none;
}

.div_mobile_005 > div {
    width: 1500px;
    flex-basis: 50%;
    
    font-size: 128px;
    font-weight: 600;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
	
	padding-left: 200px;
	
	animation: scroll_001 30s linear infinite;
}

.div_mobile_006 {
    width: 100%;
    height: 2130px;
    
    color: #3C3C3C;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
    
    overflow-x: scroll;
}

.div_mobile_006::-webkit-scrollbar {
    display: none;
}

.div_mobile_006 > div:first-child {
    width: 60%;
    
    flex-basis: 30px;
    
    margin-top: 10px;
    margin-left: 10px;
	
	font-size: 24px;
	font-weight: 600;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_006 > div:first-child > div {
    width: 10px;
    height: 10px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 10px;
    background-color: #3C3C3C;
}

.div_mobile_006 > div:nth-child(2) {
    /* width: 70%; */
	
    flex-basis: 100px;
	margin-left: 20px;
    margin-top: 30px;
	margin-right: 20px;
    font-size: 26px;
    text-align: left;
}

.div_mobile_006 > div:nth-child(3),
.div_mobile_006 > div:nth-child(4),
.div_mobile_006 > div:nth-child(5),
.div_mobile_006 > div:nth-child(6) {
    flex-basis: 450px;
    /* width: 90%; */
    
	margin-left: 20px;
	margin-right: 20px;
	
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_006 > div:nth-child(3) > span:first-child,
.div_mobile_006 > div:nth-child(4) > span:first-child,
.div_mobile_006 > div:nth-child(5) > span:first-child,
.div_mobile_006 > div:nth-child(6) > span:first-child {
    width: 100%;
    flex-basis: 20px;
    margin-top: 30px;
    font-size: 30px;
    font-weight: 600;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_006 > div:nth-child(3) > span:nth-child(2),
.div_mobile_006 > div:nth-child(4) > span:nth-child(2),
.div_mobile_006 > div:nth-child(5) > span:nth-child(2),
.div_mobile_006 > div:nth-child(6) > span:nth-child(2) {
    width: 100%;
    flex-basis: 50px;
    
    font-size: 30px;
    font-weight: 600;
    border-bottom: 2px solid #3C3C3C;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_006 > div:nth-child(3) > span:last-child,
.div_mobile_006 > div:nth-child(4) > span:last-child,
.div_mobile_006 > div:nth-child(5) > span:last-child,
.div_mobile_006 > div:nth-child(6) > span:last-child {
    width: 100%;
    flex-basis: 350px;
    font-size: 26px;
    text-align: left;
    color: #8A8A8A;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_007 {
    width: 100%;
    height: 700px;
    
    color: #3C3C3C;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    overflow-x: scroll;
}

.div_mobile_007::-webkit-scrollbar {
    display: none;
}

.div_mobile_007 > div:first-child {
    width: 100%;
    flex-basis: 340px;
    background-color: #3C3C3C;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_007 > div:first-child > div:first-child {
    flex-basis: 30%;
    width: 100%;
    color: #E6E2E1;
    
	font-size: 24px;
	font-weight: 600;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_007 > div:first-child > div:first-child > div {
    width: 10px;
    height: 10px;
    margin-left: 20px;
    margin-right: 10px;
    border-radius: 10px;
    background-color: #E6E2E1;
}

.div_mobile_007 > div:first-child > div:last-child {
    color: #ffffff;
    font-size: 110px;
    font-weight: 600;
}

.div_mobile_007 > div:last-child {
    width: 100%;
    flex-basis: 360px;
	
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
	
    overflow-x: scroll;
}

.div_mobile_007 > div:last-child::-webkit-scrollbar {
    display: none;
}

.div_mobile_007 > div:last-child img {
    width: 100%;
}

.div_mobile_008 {
    width: 100%;
    height: 900px;
    
    color: #ffffff;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    background-color: #3C3C3C;
}

.div_mobile_008 > div:first-child {
    width: 90%;
    flex-basis: 30%;
    font-size: 24px;
    color: #ffffff;
    
    margin-top: 30px;
    
    text-align: left;
}

.div_mobile_008 > div:last-child {
    width: 90%;
    flex-basis: 55%;
    font-size: 24px;
    color: #ffffff;
    
    margin-top: 30px;
    
    text-align: left;
}

.div_mobile_009 {
    width: 100%;
    height: 380px;
    overflow-x: scroll;
    
    background-color: #E6E2E1;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : flex-start;
}

.div_mobile_009::-webkit-scrollbar {
    display: none;
}

.div_mobile_009 > div {
    width: 2000px;
    flex-basis: 50%;
    
    font-size: 128px;
    font-weight: 600;
    
	margin-left: 200px;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
	
	animation: scroll_001 30s linear infinite;
}

.div_mobile_010 {
    width: 100%;
    height: 1000px;
    
    color: #3C3C3C;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    overflow-x: scroll;
}

.div_mobile_010::-webkit-scrollbar {
    display: none;
}

.div_mobile_010 > div:first-child {
    width: 100%;
    
    flex-basis: 30px;
    
    margin-top: 10px;
    
	font-size: 24px;
	font-weight: 600;
	
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_010 > div:first-child > div {
    width: 10px;
    height: 10px;
    margin-left: 20px;
    margin-right: 10px;
    border-radius: 10px;
    background-color: #3C3C3C;
}

.div_mobile_010 > div:nth-child(2) {
    /* width: 70%; */
	
	flex-basis: 100px;
	margin-left: 20px;
	margin-right: 20px;
    margin-top: 30px;
    font-size: 24px;
    text-align: left;
}

.div_mobile_010 > div:nth-child(3) {
    width: 70%;
    flex-basis: 30px;
    margin-top: 30px;
    font-size: 20px;
	text-align: left;
}

.div_mobile_010 > div:nth-child(4) {
    width: 70%;
    flex-basis: 30px;
    margin-top: 30px;
    font-size: 20px;
	text-align: left;
}

.div_mobile_010 > div:nth-child(3) > input,
.div_mobile_010 > div:nth-child(4) > input {
    width: 100%;
	font-size: 20px;
	border: none;
    border-bottom: 2px solid #3C3C3C;
}

.div_mobile_010 > div:nth-child(3) > input:focus, 
.div_mobile_010 > div:nth-child(3) > input:focus-visible, 
.div_mobile_010 > div:nth-child(3) > input:-webkit-autofill, 
.div_mobile_010 > div:nth-child(3) > input:-webkit-autofill:hover, 
.div_mobile_010 > div:nth-child(3) > input:-webkit-autofill:focus {
    outline: none;
    -webkit-text-fill-color: #333;
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    border: none;
    background-color: white;
	border-bottom: 2px solid #3C3C3C;
}

.div_mobile_010 > div:nth-child(4) > input:focus, 
.div_mobile_010 > div:nth-child(4) > input:focus-visible, 
.div_mobile_010 > div:nth-child(4) > input:-webkit-autofill, 
.div_mobile_010 > div:nth-child(4) > input:-webkit-autofill:hover, 
.div_mobile_010 > div:nth-child(4) > input:-webkit-autofill:focus {
    outline: none;
    -webkit-text-fill-color: #333;
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    border: none;
    background-color: white;
	border-bottom: 2px solid #3C3C3C;
}

.div_mobile_010 > div:nth-child(5) {
    width: 70%;
    flex-basis: 30px;
    margin-top: 30px;
    font-size: 20px;
	font-weight: 600;
	color: #3C3C3C;
	text-align: left;
	
	border-bottom: 2px solid #3C3C3C;
	
	position: relative;
}

.div_mobile_010 > div:nth-child(5) > i {
    position: absolute;
    top: 0px;
    right: 0px;
}

.div_mobile_010 > div:nth-child(6) {
    width: 100%;
    flex-basis: 600px;
	
	display : flex;
	flex-direction : row;
	justify-content : center;
	align-items : center;
	
	position: relative;
}

/* .div_mobile_010 > div:nth-child(4) > div:last-child {
    position: absolute;
    bottom: 35px;
    z-index: 9999;
    
    width: 350px;
    height: 180px;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : flex-start;
    flex-wrap: wrap;
}

.div_mobile_010 > div:nth-child(4) > div:last-child > div {
    flex-basis: 50%;
    height: 30%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_010 > div:nth-child(4) > div:last-child > div > span {
    width: 80%;
    margin-left: 25px;
    text-align: left;
    font-size: 15px;
} */

.div_mobile_011 {
    width: 100%;
    height: 350px;
    color: #ffffff;
    background-color: #3C3C3C;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_011 > div:first-child {
	width: 100%;
	
    flex-basis: 50%;
	
    overflow-x: scroll;
}

.div_mobile_011 > div:first-child::-webkit-scrollbar {
    display: none;
}

.div_mobile_011 > div:first-child div {
	width: 1000px;
	
	margin-left: 200px;
	
    font-size: 128px;
    font-weight: 600;
	
	animation: scroll_001 30s linear infinite;
}

.div_mobile_011 > div:nth-child(2),
.div_mobile_011 > div:nth-child(3),
.div_mobile_011 > div:nth-child(4),
.div_mobile_011 > div:nth-child(5) {
    font-size: 20px;
    font-weight: 600;
	text-align: left;
	padding-left: 20px;
	margin-top: 10px;
}
</style>